import { startTransition, useEffect, useState } from "react";
import { loopingPagerRingDistance } from "#looping-pager-ring";

/**
 * Which pages render content. The current page renders at once; pages within `preloadDistance`
 * around the ring mount in a transition after it paints, so wrapping to the last page never slows
 * the first one's opening. A mounted page stays mounted.
 */
export function useLoopingPagerLoadedKeys(
  keys: readonly string[],
  index: number,
  preloadDistance: number,
): (key: string) => boolean {
  const currentKey = keys[index];
  const nearbySignature = keys
    .filter(
      (_, keyIndex) => loopingPagerRingDistance(keyIndex, index, keys.length) <= preloadDistance,
    )
    .join("\n");
  const [loadedKeys, setLoadedKeys] = useState<ReadonlySet<string>>(() => new Set());
  useEffect(() => {
    const nearbyKeys = nearbySignature.split("\n");
    startTransition(() => {
      setLoadedKeys((previous) => {
        const missing = nearbyKeys.filter((key) => key !== "" && !previous.has(key));
        return missing.length === 0 ? previous : new Set([...previous, ...missing]);
      });
    });
  }, [nearbySignature]);
  return (key) => key === currentKey || loadedKeys.has(key);
}
